import type {
  FetchAuthSessionOptions,
  AuthSession
} from 'aws-amplify/auth'

export default function () {
  const { apiClient } = useApiClient()
  const session = useState<TNullable<AuthSession>>('session', () => null)
  const isAuthenticated = computed(() => !!session.value?.tokens?.accessToken)
  const userProfile = useState<TNullable<TUserProfile>>(() => null)
  const followeesIds = useState<Set<string> | null>(() => null)

  const { public: { NUXT_DASHBOARD_DOMAIN } } = useRuntimeConfig()

  async function getToken (options?: FetchAuthSessionOptions) {
    try {
      const tokens = await useNuxtApp().$Amplify.Auth.fetchAuthSession(options)

      const serializableSession = {
        credentials: tokens.credentials
          ? {
            ...tokens.credentials,
            expiration: tokens.credentials.expiration
          }
          : undefined,
        identityId: tokens.identityId || undefined,
        tokens: tokens.tokens
          ? {
            accessToken: tokens.tokens.accessToken?.toString(),
            idToken: tokens.tokens.idToken?.toString(),
            signInDetails: tokens.tokens.signInDetails
          }
          : undefined,
        userSub: tokens?.userSub || undefined
      }

      session.value = serializableSession as any

      return session.value?.tokens?.accessToken.toString()
    } catch (e) {
      console.error(e)
      return null
    }
  }

  async function getUserProfile () {
    try {
      userProfile.value = await apiClient.get('/api/me/')
      return userProfile.value
    } catch (e) {
      return Promise.reject(e)
    }
  }

  async function getFolloweesIds () {
    try {
      followeesIds.value = new Set((await apiClient.get('/api/followers/folowees-check')).followees.map(followee => followee.followeeId))
    } catch (e) {
      return Promise.reject(e)
    }
  }

  async function signOut () {
    window.location.href = NUXT_DASHBOARD_DOMAIN + '?webLogout=true'
  }

  return {
    userProfile,
    session,
    isAuthenticated,
    followeesIds,
    getToken,
    getUserProfile,
    getFolloweesIds,
    signOut
  }
}
